import { push } from 'connected-react-router';
import { put, select, takeLatest } from 'redux-saga/effects';

import { EWizardSteps } from '../../utils/enums';
import { STEPS_OPEN_STEP_REQUEST, STEPS_SET_COMPLETED_REQUEST } from '../actions/actionTypes';
import { setCompletedStep, setCurrentStep } from '../actions/steps';
import { getCurrentStep } from '../reducers/wizard';

function* openStepSaga({ payload }) {
  try {
    yield select(getCurrentStep);

    yield put(setCurrentStep(payload));

    //console.log('openStepSaga pathname', pathname);

    if (payload === EWizardSteps.INTEGRATIONS) {
      yield put(push('/social-planner/integrations'));
    } else if (payload === EWizardSteps.CAMPAIGN) {
      yield put(push('/social-planner/campaign'));
    } else if (payload === EWizardSteps.POST) {
      yield put(push('/social-planner/post'));
    } else if (payload === EWizardSteps.PUBLISH) {
      yield put(push('/social-planner/publish'));
    } else if (payload === EWizardSteps.RESULT) {
      yield put(push('/social-planner/result'));
    }
  } catch (error) {
    //console.log('openStepSaga error', error);
  }
}

export function* openStepWatcher() {
  yield takeLatest(STEPS_OPEN_STEP_REQUEST, openStepSaga);
}

function* setStepCompletedSaga({ payload }) {
  try {
    yield put(setCompletedStep(payload));
  } catch (error) {
    console.log('setStepCompletedSaga error', error);
  }
}

export function* setStepCompletedWatcher() {
  yield takeLatest(STEPS_SET_COMPLETED_REQUEST, setStepCompletedSaga);
}
